export default "__VITE_ASSET__9NeRXfyE__"